// First-party cookie/consent store (GDPR / TTDSG friendly, opt-in).
const KEY = 'nb_cookie_consent';
export const CONSENT_VERSION = 1;

export function getConsent() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const c = JSON.parse(raw);
    if (c.version !== CONSENT_VERSION) return null;
    return c;
  } catch {
    return null;
  }
}

export function setConsent({ statistics }) {
  const c = {
    version: CONSENT_VERSION,
    essential: true,
    statistics: !!statistics,
    timestamp: new Date().toISOString(),
  };
  try {
    localStorage.setItem(KEY, JSON.stringify(c));
  } catch {
    /* ignore */
  }
  window.dispatchEvent(new CustomEvent('nb-consent-change', { detail: c }));
  return c;
}

export function hasStatisticsConsent() {
  const c = getConsent();
  return !!(c && c.statistics);
}
